export function productTemplateTabsSetup() {
    Array.from(document.querySelectorAll('.tablinks')).forEach(
        (tab, index) => {
            tab.addEventListener('click', function () {
                clearActiveTabs();
                toggleTab(tab);
            })
        }
    );
}

function clearActiveTabs(){
    const activetabs = document.querySelectorAll('.active_tab');
    if (activetabs.length > 0) {
        activetabs.forEach(
            (tab) => { tab.classList.remove('active_tab') }
        );
    }
}

function toggleTab(tab){
    tab.classList.toggle('active_tab');
    const activetabIndex = tab.getAttribute('data-tab-index');
    const tabcontent = document.querySelector('.tabcontent[data-tab-index="' + activetabIndex + '"]');
    tabcontent.classList.toggle('active_tab');
}



